import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IPhoneApplication} from "../types/IPhoneApplication";

const applicationLink = apiPath.applications.create.base;

export const postPhoneApplication = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postPhoneApplication: build.mutation<{uuid: string; phone: string}, IPhoneApplication>({
            query: (body) => {
                return {
                    method: "POST",
                    url: applicationLink,
                    body
                };
            },
            transformErrorResponse: (error) => {
                return error.data;
            }
        })
    })
});

export const {usePostPhoneApplicationMutation} = postPhoneApplication;
import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IPhoneApplication} from "../types/IPhoneApplication";

const applicationLink = apiPath.applications.create.base;

export const postPhoneApplication = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postPhoneApplication: build.mutation<{uuid: string; phone: string}, IPhoneApplication>({
            query: (body) => {
                return {
                    method: "POST",
                    url: applicationLink,
                    body
                };
            },
            transformErrorResponse: (error) => {
                return error.data;
            }
        })
    })
});

export const {usePostPhoneApplicationMutation} = postPhoneApplication;
